/** @format */

import React, { useEffect, useState, useRef } from "react";
import { format } from "date-fns";

import "react-toastify/dist/ReactToastify.css";

import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import "primereact/resources/primereact.min.css"; //core css
import "primeicons/primeicons.css";

const Form8 = () => {
  const [formData, setFormData] = useState({
    doc_type: "8",
    ref_field: null,
    dep_id: null,
    requester_id: null,
    project: null,
    project_head: null,
    project_supervisor: null,
    nouvelle_realisation: false,
    renovation: false,
    maintenance: false,
    mecanique: false,
    electronique: false,
    amenagement: false,
    work_description: null,
    materials_acquisition: null,
    external_service: null,
    req_date: null,
    approver_1: null,
    approver_2: null,
    approver_3: null,
    approver_4: null,
    approver_5: null,
    approver_6: null,
    approver_7: null,
    approver_8: null,

    // ...
  });

  const combinedFormData = {
    ...formData,
  };
  console.log(formData);
  const handleSubmit = async (e) => {
    // e.preventDefault();

    // Make a fetch() request to submit the form data to the backend.
    const response = await fetch("http://localhost:5000/api/formSubmit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: localStorage.token,
      },
      body: JSON.stringify(combinedFormData),
    });

    // Check the response status code.
    if (response.status === 200) {
      // Success!
      document.getElementById("btn-submit-form").disabled = true;

      toast.current.show({
        severity: "success",
        summary: "succès",
        detail: "Demande envoyée",
      });
    } else {
      // Error!
      alert("An error occurred while submitting the form data.");
    }
  };

  const [currentDate, setCurrentDate] = useState(new Date());

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDate(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setFormData({ ...formData, req_date: currentDate });
  }, [currentDate]);

  // work type selection --------------------------------------------------------------------
  const [nouvelle_realisationNextState, setNouvelle_realisationNextState] =
    useState(true);
  const [renovationNextState, setRenovationNextState] = useState(true);

  const [maintenanceNextState, setMaintenanceNextState] = useState(true);

  const handleCheckChangeNR = (stateToggle) => {
    if (nouvelle_realisationNextState === true) {
      stateToggle = false;
    } else if (nouvelle_realisationNextState === false) {
      stateToggle = true;
    }
    setNouvelle_realisationNextState(stateToggle);
  };

  const handleCheckChangeREN = (stateToggle) => {
    if (renovationNextState === true) {
      stateToggle = false;
    } else if (renovationNextState === false) {
      stateToggle = true;
    }
    setRenovationNextState(stateToggle);
  };

  const handleCheckChangeMAINT = (stateToggle) => {
    if (maintenanceNextState === true) {
      stateToggle = false;
    } else if (maintenanceNextState === false) {
      stateToggle = true;
    }
    setMaintenanceNextState(stateToggle);
  };

  //   console.log(combinedFormData.renovation);

  //-----------------------------------------------------------------------------------------

  // work nature selection --------------------------------------------------------------------
  const [mecaniqueNextSelection, setMecaniqueNextSelection] = useState(true);
  const [electroniqueNextSelection, setElectroniqueNextSelection] =
    useState(true);

  const [amenagementNextSelection, setAmenagementNextSelection] =
    useState(true);

  const handleCheckChangeMec = (stateToggle) => {
    if (mecaniqueNextSelection === true) {
      stateToggle = false;
    } else if (mecaniqueNextSelection === false) {
      stateToggle = true;
    }
    setMecaniqueNextSelection(stateToggle);
  };

  const handleCheckChangeElectro = (stateToggle) => {
    if (electroniqueNextSelection === true) {
      stateToggle = false;
    } else if (electroniqueNextSelection === false) {
      stateToggle = true;
    }
    setElectroniqueNextSelection(stateToggle);
  };

  const handleCheckChangeAmen = (stateToggle) => {
    if (amenagementNextSelection === true) {
      stateToggle = false;
    } else if (amenagementNextSelection === false) {
      stateToggle = true;
    }
    setAmenagementNextSelection(stateToggle);
  };

  //-----------------------------------------------------------------------------------------

  const [departments, setDepartments] = useState([]);

  async function getDepartments() {
    try {
      const getDep = await fetch("//localhost:5000/api/departments");
      const parsRes = await getDep.json();
      setDepartments(parsRes);
    } catch (err) {
      console.error(err.message);
    }
  }

  const [emps, setEmps] = useState([]);

  const fetchEmp = async () => {
    // Fetch the forms and their IDs from the database.
    const response = await fetch("/api/employees");
    const data = await response.json();

    setEmps(data);
    // console.log(forms);
  };

  const handleProjectHeadSelection = (e) => {
    e.preventDefault();
    setFormData({ ...formData, project_head: e.target.value });
  };

  const handleDepartmentSelection = (e) => {
    e.preventDefault();
    setFormData({ ...formData, dep_id: e.target.value });
  };

  const handleProjectSupervisorSelection = (e) => {
    e.preventDefault();
    setFormData({ ...formData, project_supervisor: e.target.value });
  };

  //get approvers ----------------------------------------------

  const [approvers, setApprovers] = useState([]);
  const fetchAppro = async () => {
    // Fetch the Docs and their IDs from the database.
    const response = await fetch("http://localhost:5000/api/approvers");
    const data = await response.json();

    setApprovers(data);
    // console.log(approvers);
  };

  //get documents -------------------------------------------

  const [docs, setDocs] = useState([]);
  const [isNotEmpty, setIsNotEmpty] = useState(false);
  const fetchDocs = async () => {
    // Fetch the Docs and their IDs from the database.
    const response = await fetch("http://localhost:5000/api/documents");
    const data = await response.json();

    setDocs(data);
    // console.log(docs);
    let docLen = docs.length;

    if (docLen > 0) {
      setIsNotEmpty(true);
    }
  };

  // console.log(formData);

  //initialize approvers status for the request------------
  const [currentDocIsSelected, setCurrentDocIsSelected] = useState(false);
  const [currentDoc, setCurrentDoc] = useState([]);
  const getCurrentDoc = () => {
    // console.log(isNotEmpty);
    if (docs.length !== 0) {
      const current = docs.filter(
        (doc) => doc.doc_type_id == formData.doc_type
      );
      setCurrentDoc(current);
      setCurrentDocIsSelected(true);
    }
  };

  // console.log(currentDocIsSelected);

  // console.log(formData);
  const initializeApproversState = () => {
    if (currentDoc.length > 0) {
      const firstDoc = currentDoc;
      const currDoc = firstDoc[0];

      const currDocArray = Object.entries(currDoc);

      let filteredDocArray = currDocArray.filter(
        (innerArr) =>
          innerArr[0] !== "doc_type_id" && innerArr[0] !== "doc_tittle"
      );

      // console.log(filteredDocArray);

      let updatedFormData = { ...formData };
      for (let i = 0; i < filteredDocArray.length; i++) {
        const key = filteredDocArray[i][0];
        const value = filteredDocArray[i][1];
        const fdKey = Object.entries(formData);
        for (let j = 0; j < fdKey.length; j++) {
          if ((value === 0) | (value === null)) {
            if (fdKey[j][0] == key) {
              updatedFormData[key] = null;
            }
          } else {
            updatedFormData[key] = false;
          }
        }
      }
      setFormData(updatedFormData);
    }
  };

  // console.log(formData);

  // console.log(formData.approver_1);

  //--------------------------------------------------------
  const [name, setName] = useState("");
  const [requesterId, setRequesterId] = useState("");

  async function getName() {
    try {
      const resp = await fetch("//localhost:5000/api/dashboard", {
        method: "GET",
        headers: { token: localStorage.token },
      });
      const parsRes = await resp.json();
      // console.log(parsRes);

      setName(parsRes.emp_name);
      setRequesterId(parsRes.emp_id);
    } catch (err) {
      console.error(err.message);
    }
  }

  useEffect(() => {
    getName();
    fetchDocs();
    fetchAppro();
    getCurrentDoc();
    fetchEmp();
    getDepartments();
  }, []);

  useEffect(() => {
    getCurrentDoc();
  }, [docs]);

  useEffect(() => {
    initializeApproversState();
  }, [currentDoc]);

  const dataValidation = () => {
    if (
      (formData.ref_field == null) |
      (formData.dep_id == null) |
      (formData.project == null)
    ) {
      document.getElementById("btn-submit-form").disabled = true;
    } else {
      document.getElementById("btn-submit-form").disabled = false;
    }
  };

  useEffect(() => {
    dataValidation();
  }, [formData.ref_field, formData.dep_id, formData.project]);

  // confirmation dialog -------------------------------------------

  const toast = useRef(null);

  const accept = () => {
    toast.current.show({
      severity: "info",
      summary: "conifrmé",
      detail: "demande envoyée",
      life: 3000,
    });
  };

  const reject = () => {
    toast.current.show({
      severity: "warn",
      summary: "Annulée",
      detail: "demande annulée",
      life: 3000,
    });
  };

  const confirm1 = () => {
    confirmDialog({
      message: "Confirmer l'envoie de la demande?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Oui",
      rejectLabel: "Non",
      accept: () => handleSubmit(),
      reject,
    });
  };

  // ------------------------------------------------------------

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className='container-fluid p-5 h1'>
          <h5 className='h5 text-center'>
            DEMANDE DE TRAVAUX HORS PROJET DE RECHERCHE
          </h5>
        </div>

        <div className='doc-body-top-submit'>
          <span>bou-ismail, le:</span>
          <p>{format(currentDate, "MM/dd/yyyy")}</p>
        </div>

        <div className='container mb-3'>
          <div className='input-group mb-3 mt-3'>
            <span className='input-group-text' htmlFor='ref_field'>
              No.
            </span>
            <input
              className='form-control'
              type='text'
              id='ref_field'
              name='ref_field'
              value={formData.ref_field}
              onChange={(e) =>
                setFormData({ ...formData, ref_field: e.target.value })
              }
            />
          </div>

          <label className='form-label' htmlFor='dep_id'>
            Equipe /Division:
          </label>
          <select
            id='dep_id'
            className='form-select mb-3'
            onChange={handleDepartmentSelection}
          >
            <option disabled selected value>
              {" "}
              -- selectionnez --{" "}
            </option>

            {departments.map((dep) => (
              <option key={dep.dep_id} value={dep.dep_id}>
                {dep.dep_name}
              </option>
            ))}
          </select>

          <div className='input-group mb-3 mt-3'>
            <span className='input-group-text' htmlFor='project'>
              Projet
            </span>
            <input
              className='form-control'
              type='text'
              id='project'
              name='project'
              value={formData.project}
              onChange={(e) =>
                setFormData({ ...formData, project: e.target.value })
              }
            />
          </div>

          <label className='form-label' htmlFor='project_head'>
            Chef de projet:
          </label>
          <select
            id='project_head'
            className='form-select mb-3'
            onChange={handleProjectHeadSelection}
          >
            <option disabled selected value>
              {" "}
              -- selectionnez --{" "}
            </option>

            {emps.map((emp) => (
              <option key={emp.emp_id} value={emp.emp_id}>
                {emp.emp_name}
              </option>
            ))}
          </select>

          <label className='form-label' htmlFor='project_supervisor'>
            Chargé de suivi des travaux:
          </label>
          <select
            id='project_supervisor'
            className='form-select mb-3'
            onChange={handleProjectSupervisorSelection}
          >
            <option disabled selected value>
              {" "}
              -- selectionnez --{" "}
            </option>

            {emps.map((emp) => (
              <option key={emp.emp_id} value={emp.emp_id}>
                {emp.emp_name}
              </option>
            ))}
          </select>
          <div className='options-selection'>
            {/*work type selection ---------------------------------------------------------------------------------------------------*/}
            <form
              id='work_type_selection'
              className='form-control work_type_selection'
            >
              <div className='work-type-selection'>
                <label htmlFor='work_type_selection'>Type de travaux:</label>
                <div className='container mt-3 work-type-checkboxes'>
                  <div className='check-box-select'>
                    <label
                      className='form-label'
                      htmlFor='Nouvelle realisation'
                    >
                      Nouvelle réalisation:
                    </label>
                    <input
                      type='checkbox'
                      id='Nouvelle realisation'
                      value={nouvelle_realisationNextState}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          nouvelle_realisation: e.target.value,
                        });
                        handleCheckChangeNR();
                      }}
                    />
                  </div>

                  <div className='check-box-select'>
                    <label className='form-label' htmlFor='Renovation'>
                      Rénovation:
                    </label>
                    <input
                      type='checkbox'
                      id='Renovation'
                      value={renovationNextState}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          renovation: e.target.value,
                        });
                        handleCheckChangeREN();
                      }}
                    />
                  </div>

                  <div className='check-box-select'>
                    <label className='form-label' htmlFor='Maintenance'>
                      Maintenance:
                    </label>
                    <input
                      className=''
                      type='checkbox'
                      id='Maintenance'
                      value={maintenanceNextState}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          maintenance: e.target.value,
                        });
                        handleCheckChangeMAINT();
                      }}
                    />
                  </div>
                </div>
              </div>
            </form>

            {/* // end of work type selection ----------------------------------------------------------------------------------------------------- */}

            {/* // work nature selection -------------------------------------------------------------------------------------------------------- */}

            <form
              id='work_nature_selection'
              className='form-control work_type_selection'
            >
              <div className='work-type-selection'>
                <label htmlFor='work_type_selection'>Nature de travaux:</label>
                <div className='container mt-3 work-type-checkboxes'>
                  <div className='check-box-select'>
                    <label className='form-label' htmlFor='mechanique'>
                      Mécanique
                    </label>
                    <input
                      type='checkbox'
                      id='mechanique'
                      value={mecaniqueNextSelection}
                      onChange={(e) => {
                        setFormData({ ...formData, mecanique: e.target.value });
                        handleCheckChangeMec();
                      }}
                    />
                  </div>

                  <div className='check-box-select'>
                    <label className='form-label' htmlFor='electronique'>
                      Electronique
                    </label>
                    <input
                      type='checkbox'
                      id='electronique'
                      value={electroniqueNextSelection}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          electronique: e.target.value,
                        });
                        handleCheckChangeElectro();
                      }}
                    />
                  </div>

                  <div className='check-box-select'>
                    <label className='form-label' htmlFor='amenagement'>
                      Aménagement
                    </label>
                    <input
                      className=''
                      type='checkbox'
                      id='Maintenance'
                      value={amenagementNextSelection}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          amenagement: e.target.value,
                        });
                        handleCheckChangeAmen();
                      }}
                    />
                  </div>
                </div>
              </div>
            </form>
            {/* // end of work nature selection --------------------------------------------------------------------------------------------- */}
          </div>

          <div className='options-selection'>
            <div className='work-description-text'>
              <label htmlFor='work_description'>
                Travaux à réaliser (Précision):
              </label>
              <textarea
                className='form-control'
                type='text'
                id='work_description'
                value={combinedFormData.work_description}
                onChange={(e) =>
                  setFormData({ ...formData, work_description: e.target.value })
                }
              />
            </div>

            {/* materials acquisition selection -----------------------------------------------------------*/}

            <div>
              <form id='materials_acquisition' className='form-control'>
                <label htmlFor='materials_acquisition'>
                  Achat matériel/ Fourniture:
                </label>
                <div className=''>
                  <div
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        materials_acquisition: e.target.value,
                      })
                    }
                    className='radio-button-select'
                  >
                    <div className='radio-box-select'>
                      <input
                        id='yesM'
                        type='radio'
                        value={true}
                        name='materials acquisition'
                      />
                      <label htmlFor='yesM'>Oui</label>
                    </div>

                    <div className='radio-box-select'>
                      <input
                        id='noM'
                        type='radio'
                        value={false}
                        name='materials acquisition'
                      />
                      <label htmlFor='noM'>Non</label>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            {/* end of materials acquisition selection --------------------------------------------------------- */}

            {/* external service selection ----------------------------------------------------------------------------- */}
            <div>
              <form id='external_service' className='form-control'>
                <label htmlFor='external_service'>Prestation externe:</label>

                <div
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      external_service: e.target.value,
                    })
                  }
                  className='radio-button-select'
                >
                  <div className='radio-box-select'>
                    <input
                      id='yesEx'
                      type='radio'
                      value={true}
                      name='external_service'
                    />
                    <label htmlFor='yesEx'>Oui</label>
                  </div>
                  <div className='radio-box-select'>
                    <input
                      id='noEx'
                      type='radio'
                      value={false}
                      name='external_service'
                    />
                    <label htmlFor='noEx'>Non</label>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* end of external service selection ------------------------------------------------------------------ */}

        <div>
          <label className='form-label' htmlFor=''>
            Approbation par le, Demandeur, Chef d'équipe, Directeur de Division,
            Coordinateur de Division, Chef D'Atelier/Chef Service, Directeur
          </label>
        </div>

        {/* <button type='submit'>Submit</button> */}
      </form>
      {/* confirmation dialog ----------------------------------------- */}
      <Toast ref={toast} />

      <div className='p-confirm-dialog	'>
        <ConfirmDialog className='p-confirm-dialog' />
      </div>

      <Button
        id='btn-submit-form'
        onClick={confirm1}
        icon='pi pi-check'
        label='soumettre'
        className='mr-2 btn btn-primary btn-submit-form'
      ></Button>

      {/* confirmation dialog ----------------------------------------- */}
      <Toast ref={toast} />
    </div>
  );
};

export default Form8;
